import type { IRole, IUser } from '~/store/user/types';

const getAccessibleTeamIdsForClinic = (
  current: IUser | undefined,
  clinicId: string | number,
  currentRole: IRole | undefined,
): number[] => {
  const clinicIdNum = Number(clinicId);
  if (!current?.roles || !current?.clinic) {
    return [];
  }

  return Array.from(
    new Set(
      current.roles
        .filter(r => r.clinic.id === clinicIdNum && r.id === currentRole?.id)
        .flatMap(r => (r.teams ?? []).map(t => t.id)),
    ),
  );
};

export default getAccessibleTeamIdsForClinic;
